import React, { FC, useContext } from 'react'
import {
    StyledBackNav,
    StyledMainScreen,
    StyledIconChevron,
} from './MainScreen.styled'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { TNToastComponent } from '../../content/TNToastNotification/TNToastNotification'
import { UserSettingProps } from '../UserSetting'
import { ScreenType, screens } from '../hooks/useScreen'

interface MainScreenProps extends UserSettingProps {
    screen: ScreenType
    /* `show` is only evaluated on sm screen */
    show?: boolean
}
export const MainScreen: FC<MainScreenProps> = ({
    screen,
    show = false,
    onEvent,
    log,
    config,
}) => {
    const { messageBanner, goBackToParent } = useContext(MyAccountContext)
    const showOnLargeScreen = screen !== 'manage-account'

    const {
        body: Screen,
        headingText,
        subHeadingText,
        parent,
        navText,
    } = screens[screen]

    return (
        <StyledMainScreen show={show}>
            {messageBanner && (
                <TNToastComponent
                    text={messageBanner.text}
                    type={messageBanner.type}
                    useMaxWidth={true}
                    forceMaxWidth={true}
                />
            )}
            {(parent || navText) && (
                <StyledBackNav
                    onClick={() => goBackToParent(true)}
                    showOnLargeScreen={showOnLargeScreen}
                >
                    <StyledIconChevron direction="left" />
                    <span>
                        {navText
                            ? navText
                            : parent
                            ? screens[parent].headingText
                            : 'Unknown Parent'}
                    </span>
                </StyledBackNav>
            )}
            <h2 className={subHeadingText ? '' : 'bottom-header'}>
                {headingText}
            </h2>
            {subHeadingText && (
                <h4 className="bottom-header">{subHeadingText}</h4>
            )}
            <Screen onEvent={onEvent} log={log} config={config} />
        </StyledMainScreen>
    )
}
